module.exports = __webpack_public_path__ + "static/entrepreneurship-hub-logo-d0d2dd043ce3006cb0718333e670c7b4.svg";